export enum PitchKind {
  LOW = 'LOW',
  HIGH = 'HIGH'
}
